<template>
  <div class="progress__wrapper">
    <div class="progress">
      <v-progress-circular indeterminate color="accent" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;

  .progress,
  .v-progress-circular {
    display: flex;
  }
}
</style>
